import type { OptionsVisibility } from '../../types/options-visibility';

/**
 * Get available list of option ids to which `isVisible` rule was applied
 *
 * @param optionsVisibility - object with a list of option ids and the `isVisible` rule
 * @param lookupValues - list of entities that will be used to filter invalid elements in options list
 * @param optionKey - property name of the entity from the lookupValues list with which value will be compared
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAvailableOptionsVisibilityRule = <T extends { [key: string]: any }>(
	{ options, isVisible }: OptionsVisibility,
	lookupValues: T[] = [],
	optionKey: string,
): OptionsVisibility => ({
	isVisible,
	options: options.filter((option) => lookupValues.some((value) => value[optionKey] === option)),
});
